/**
 * Règle client : le statut professionnel dépend de la fonction (miroir de ProStatusRules côté back-end,
 * qui reste l'autorité).
 *  - Médecin (secteur 1)                 : REMPLACANT uniquement ;
 *  - Infirmier(ère) (secteurs 2 et 3)    : VACATAIRE ou TITULAIRE ;
 *  - autres fonctions                    : pas de restriction.
 */
export type ProStatusValue = 'VACATAIRE' | 'TITULAIRE' | 'REMPLACANT';

export const ALL_PRO_STATUS_OPTIONS: { id: ProStatusValue; name: string }[] = [
  { id: 'VACATAIRE', name: 'Vacataire' },
  { id: 'TITULAIRE', name: 'Titulaire' },
  { id: 'REMPLACANT', name: 'Remplaçant' },
];

export function allowedProStatuses(secteurId: number | string | null | undefined): ProStatusValue[] {
  const id = Number(secteurId);
  if (id === 1) {
    return ['REMPLACANT'];
  }
  if (id === 2 || id === 3) {
    return ['VACATAIRE', 'TITULAIRE'];
  }
  return ['VACATAIRE', 'TITULAIRE', 'REMPLACANT'];
}

/** Options du menu « Statut professionnel » pour la fonction choisie. */
export function proStatusOptionsFor(secteurId: number | string | null | undefined) {
  const allowed = allowedProStatuses(secteurId);
  return ALL_PRO_STATUS_OPTIONS.filter((o) => allowed.includes(o.id));
}

/** Statut à sélectionner : le statut courant s'il est autorisé, sinon le défaut de la fonction (REMPLACANT / VACATAIRE). */
export function resolveProStatus(secteurId: number | string | null | undefined, current: string | null | undefined): ProStatusValue {
  const allowed = allowedProStatuses(secteurId);
  if (current && (allowed as string[]).includes(current)) {
    return current as ProStatusValue;
  }
  return Number(secteurId) === 1 ? 'REMPLACANT' : 'VACATAIRE';
}
